// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"generalizedModal_backdrop__WTAMz"};